import React, { FC, useEffect, useRef, useState } from 'react';
import translate from '@translate';
import { useDispatch, useSelector } from 'react-redux';
import { setLocationParams } from 'src/resources/location/reducer';
import TopBlock from './TopBlock';
import { getProvidersListFetch } from 'src/resources/providersList/reducer';
import { RootStoreType } from 'src/types/store';
import { allColumns } from './constants';
import StoreIcon from '@mui/icons-material/Store';
import TableSimple from 'src/components/TableSimple';
import { TableRefType } from 'src/types/table';
import { useCheckPermission } from 'src/utils/checkPermission';

interface IntegrationListContainerProps {
}

const IntegrationListContainer: FC<IntegrationListContainerProps> = (props) => {
    const dispatch = useDispatch();
    const tableRef = useRef<TableRefType>();
    const [activeTab, setActiveTab] = useState<string>('SHOPTET');

    const loading = useSelector((state: RootStoreType) => state.providersList.loading);
    const providersData = useSelector((state: RootStoreType) => state.providersList.dataSystem);
    const boolNumberCodes = useSelector((state: RootStoreType) => state.constantsCodes.data.boolNumberCodes);

    const permissionMappingDetail = useCheckPermission('INTEGRATION.MAPPING_STATUSES') || useCheckPermission('INTEGRATION.MAPPING_SHIPPING_METHODS') || useCheckPermission('INTEGRATION.MAPPING_PAYMENT_METHODS');
    useEffect(() => {
        dispatch(setLocationParams({ name: translate('providers.title') }));
        dispatch(getProvidersListFetch({ system: activeTab }));
    }, [activeTab]);

    const reloadProvidersList = () => {
        dispatch(getProvidersListFetch({ system: activeTab }));
    };

    return (
        <>
            <TopBlock
                reloadProvidersList={reloadProvidersList}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                systems={['SHOPTET', 'SHOPIFY', 'WOOCOMMERCE']}
            />
            <TableSimple
                tableRef={tableRef}
                rowIdKey="ID"
                rows={providersData || []}
                loading={loading}
                columsLabelPrefix="providers.table"
                allColumns={allColumns}
                initSort={{ column: 'ID', direction: 'DESC' }}
                rowActions={[
                    {
                        icon: <StoreIcon />,
                        label: translate('integration.action.mappingDetail'),
                        getLink: (row) => `/integration/${row.ID}/`,
                        hiddenFce: () => !permissionMappingDetail
                    }
                ]}
                selectOptions={{
                    boolNumberCodes
                }}
                heightVariant="top-tab-2"
                fullHeight
                optionsSessionName="providersTable"
            />
        </>
    );
};

export default IntegrationListContainer;
